export default __webpack_public_path__ + "static/Plastic-Recycling-bae0bb9fe1a64454e30d47d6e70e8a84.jpg";